<div class="h-full overflow-auto">
  <div
    id="section-aboutus"
    class="relative w-auto h-[600px] inset-0 overflow-hidden bg-emphasis rounded-lg m-2 p-2"
  >
    <img
      src="images/aboutUsImage.jpg"
      class="absolute inset-0 w-full h-full object-cover"
      [alt]="'home.aboutUsTitle' | translate"
    />
    <div class="bg-gradient absolute top-0 right-0 h-full w-full"></div>
    <div
      class="absolute top-0 right-0 h-full w-full md:w-2/3 flex flex-col justify-center items-end p-8 md:p-16 text-white text-right"
    >
      <h2 class="text-4xl font-bold mb-4 border-b-2 pb-4">{{ 'home.aboutUsTitle' | translate }}</h2>
      <p class="text-lg md:text-xl max-w-xl">
        {{ 'home.aboutUsText' | translate }}
      </p>
      <div class="flex justify-end gap-2 mt-4">
        <a
          pButton
          [outlined]="true"
          [severity]="'contrast'"
          [label]="'footer.flg' | translate"
          href="https://www.fanny-leicht.de"
          target="_blank"
          rel="noopener noreferrer"
        >
        </a>
        <a
          pButton
          [outlined]="true"
          [severity]="'contrast'"
          [label]="'footer.instagram' | translate"
          href="https://www.instagram.com/technikflg/"
          target="_blank"
          rel="noopener noreferrer"
        >
        </a>
      </div>
    </div>
  </div>

  <div id="card-flex" class="flex flex-row m-2 mt-3 gap-2">
    <div id="section-events" class="bg-emphasis h-fit rounded-lg p-2 flex-1">
      <h2
        class="text-xl font-bold mb-3 border-b-2 border-neutral-500 w-fit flex navtitle items-end"
        [routerLink]="'/events'"
      >
        <span>{{ 'home.eventsTitle' | translate }}</span>
        <mat-icon iconClass="ml-2">arrow_right_alt</mat-icon>
      </h2>
      @defer (hydrate on viewport) {
        @if (events.isLoading()) {
          <p-skeleton height="1.6875rem" />
        } @else {
          @if (events.error()) {
            <span class="text-xl italic text-orange-500">
              {{ 'home.eventsError' | translate }}
            </span>
          } @else {
            @for (evt of events.value(); track $index) {
              <event-item
                [event]="evt"
                [location]="evt.location"
                (eventClicked)="openEventDetails(evt._id)"
              ></event-item>
            } @empty {
              <span class="text-xl text-neutral-500"> {{ 'home.eventsEmpty' | translate }} </span>
            }
          }
        }
      } @placeholder {
        <p-skeleton height="1.6875rem" />
      }
    </div>

    <div id="section-gallery" class="bg-emphasis h-fit rounded-lg p-2 flex-1">
      <h2
        class="text-xl font-bold mb-3 border-b-2 border-neutral-500 w-fit flex navtitle items-end"
        [routerLink]="'/gallery'"
      >
        <span> {{ 'home.imagesTitle' | translate }}</span>
        <mat-icon iconClass="ml-2">arrow_right_alt</mat-icon>
      </h2>
      @defer (hydrate on viewport) {
        @if (images.isLoading()) {
          <p-skeleton height="1.6875rem" />
        } @else {
          @if (images.error()) {
            <span class="text-xl italic text-orange-500">
              {{ 'home.imagesError' | translate }}
            </span>
          } @else {
            @for (img of images.value(); track $index) {
              <div>img</div>
            } @empty {
              <span class="text-xl text-neutral-500"> {{ 'home.imagesEmpty' | translate }} </span>
            }
          }
        }
      } @placeholder {
        <p-skeleton height="1.6875rem" />
      }
    </div>
  </div>
</div>
